import memberSpaceIcon from "../Assets/icons/member_space.svg";
import servicesHeartIcon from "../Assets/icons/services_heart.svg";
import welcomeIcon from "../Assets/icons/welcome_hearts.svg";
import Layout from "../Components/Layout";

function View({ translate }) {
  return (
    <Layout centered>
      <div className="acoris-subscription-done">
        <div className="acoris-subscription-done__content">
          <div className="acoris-subscription-done__header">
            <img
              src={welcomeIcon}
              alt=""
              className="acoris-subscription-done__icon"
            />
            <h1 className="acoris-subscription-done__title">
              {translate?.TITLE}
            </h1>
          </div>

          <div className="acoris-subscription-done__yousign">
            <p>
              {translate?.YOUSIGN?.TEXT ||
                translate?.INFOBOX?.TEXT ||
                "Un email vous a été envoyé de la part de Universign avec l'ensemble des documents signés."}
            </p>
          </div>

          <div className="acoris-subscription-done__member-space">
            <img src={memberSpaceIcon} alt="" />
            <p
              dangerouslySetInnerHTML={{
                __html:
                  translate?.MEMBER_SPACE?.TEXT ||
                  "Accéder à votre <strong>espace adhérent</strong> dès réception de vos identifiants, dans notre e-mail de bienvenue !",
              }}
            />
          </div>

          <button
            type="button"
            className="acoris-subscription-done__button"
            onClick={() => {
              window.location.href = "https://www.acoris-mutuelles.fr/";
            }}
          >
            <img src={servicesHeartIcon} alt="" />
            <span>
              {translate?.BUTTON?.DISCOVER_SERVICES ||
                "Découvrez tous vos services"}
            </span>
          </button>
        </div>
      </div>
    </Layout>
  );
}

export default View;
